const Unit = {
  M2: { key: "m2", name: "m²" },
};
export default Unit;
